<script setup lang="ts">
import type { IOptimizeImageOptions } from '~~/src/composables/elements.client'
import { parseImageKitOptions } from '~~/src/plugins/image-kit'

function optimize(url: string, options: IOptimizeImageOptions) {
  return `${url}${parseImageKitOptions(options)}`
}
</script>

<template>
  <div>
    <NuxtLink
      to="/feature/agents"
      aria-label="Learn more about turning any automation into an App"
    >
      <div class="flex justify-center bg-[#DEF5FC] relative ">
        <div class="absolute top-0 right-0 bottom-0 left-0 opacity-[0.04] mix-blend-multiply" style="opacity: 0.04; background: linear-gradient(180deg, #FFF 71.52%, #000 100%);" />
        <picture>
          <source
            :srcset="optimize('https://ik.imagekit.io/b6q4ycaer/snack/long-banner-header.jpg', { width: 1584, height: 192, quality: 90 })"
            media="(min-width: 677px)"
          >
          <img
            :src="optimize('https://ik.imagekit.io/b6q4ycaer/snack/long-banner-header-mobile.jpg', { width: 812, height: 192 })"
            alt="Promotional banner with a light blue background and subtle graphic elements."
            class="max-h-[160px] w-full"
            width="812"
            height="192"
            fetchpriority="high"
          >
        </picture>
      </div>
    </NuxtLink>
  </div>
</template>
